import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, Transition as _Transition } from "vue";
const _hoisted_1 = {
  class: "searchOverlay ut-searchOverlay"
};
const _hoisted_2 = {
  class: "empty-container"
};
const _hoisted_3 = {
  class: "content"
};
const _hoisted_4 = {
  key: 0,
  class: "searching"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_search_bar_search_field = _resolveComponent("search-bar-search-field");
  const _component_icon = _resolveComponent("icon");
  const _component_image_background = _resolveComponent("image-background");
  const _component_loader = _resolveComponent("loader");
  const _component_user_search_result = _resolveComponent("user-search-result");
  const _component_speach_search_result = _resolveComponent("speach-search-result");
  const _component_infinite_loading = _resolveComponent("infinite-loading");
  const _component_grid_layout = _resolveComponent("grid-layout");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_search_bar_search_field, {
    ref: "searchField",
    "search-user": _ctx.searchUser,
    "initial-search-term": _ctx.initialSearchTerm,
    onSearchtermchanged: _cache[0] || (_cache[0] = $event => _ctx.throttledHandleSearchTermChange($event.searchTerm))
  }, null, 8, ["search-user", "initial-search-term"]), _createVNode(_Transition, {
    name: "fade"
  }, {
    default: _withCtx(() => [_withDirectives(_createElementVNode("div", _hoisted_1, [_createVNode(_component_icon, {
      icon: "close",
      size: "default",
      class: "closeButton ut-close-search-button",
      onClick: _cache[1] || (_cache[1] = $event => _ctx.close())
    }), _withDirectives(_createElementVNode("div", _hoisted_2, [_createVNode(_component_image_background, {
      titre: _ctx.$t('search.no.result'),
      "sous-titre": _ctx.$t('search.no.action'),
      "image-url": "/public/images/empty-states/no_speach.png"
    }, null, 8, ["titre", "sous-titre"])], 512), [[_vShow, !_ctx.searching && _ctx.empty]]), _createVNode(_component_grid_layout, {
      class: "grid-layout"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_ctx.searching ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_component_loader)])) : _createCommentVNode("", true), !_ctx.searching && _ctx.searchUser && _ctx.users.totalNumberOfUsersFound !== 0 ? (_openBlock(), _createBlock(_component_user_search_result, {
        key: 1,
        "total-number-of-users-found": _ctx.users.totalNumberOfUsersFound,
        "users-found": _ctx.users.usersFound,
        "search-term": _ctx.searchTerm,
        onLoadNewPage: _ctx.onLoadNewPageUsers,
        "number-of-items-to-load-in-advance": _ctx.users.numberOfUsersToDisplay,
        "number-of-items-loaded": _ctx.users.usersFound.length,
        "workflow-enabled": _ctx.workflowEnabled
      }, null, 8, ["total-number-of-users-found", "users-found", "search-term", "onLoadNewPage", "number-of-items-to-load-in-advance", "number-of-items-loaded", "workflow-enabled"])) : _createCommentVNode("", true), !_ctx.searching && (_ctx.speaches.totalNumberOfSpeachesFound !== 0 || _ctx.speaches.langFilter != null) ? (_openBlock(), _createBlock(_component_speach_search_result, {
        key: 2,
        ref: "speachSearchResult",
        "speaches-found": _ctx.speaches.speachesFound,
        "available-languages": _ctx.speaches.availableLanguages,
        "total-number-of-speaches-found": _ctx.speaches.totalNumberOfSpeachesFound,
        sort: _ctx.speaches.sort,
        "lang-filter": _ctx.speaches.langFilter,
        onSortspeachsearch: _cache[2] || (_cache[2] = $event => _ctx.changeSpeachSort($event.sort)),
        onSelectlangfilter: _cache[3] || (_cache[3] = $event => _ctx.changeSpeachLangFilter($event.filter))
      }, null, 8, ["speaches-found", "available-languages", "total-number-of-speaches-found", "sort", "lang-filter"])) : _createCommentVNode("", true), _ctx.speaches.speachesFound.length < _ctx.speaches.totalNumberOfSpeachesFound ? (_openBlock(), _createBlock(_component_infinite_loading, {
        key: 3,
        ref: "infiniteLoader",
        distance: 250,
        onInfinite: _ctx.infiniteHandler
      }, {
        "no-more": _withCtx(() => _cache[4] || (_cache[4] = [_createElementVNode("div", null, null, -1)])),
        spinner: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_loader)])]),
        _: 1
      }, 8, ["onInfinite"])) : _createCommentVNode("", true)])]),
      _: 1
    })], 512), [[_vShow, _ctx.overlayOpen]])]),
    _: 1
  })]);
}